// Webpack Imports
import * as bootstrap from 'bootstrap';
import $ from 'jquery';
import 'slick-carousel';
import Isotope from "isotope-layout";
import Plyr from 'plyr';

( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();
window.jQuery = window.$ = $; 

$('.clients-home').slick({
	infinite: true,
	autoplay:  true,
	arrows: false,
	autoplaySpeed: 600,
	slidesToShow: 10,
	slidesToScroll: 1,
	responsive: [
		{
		  breakpoint: 991,
		  settings: {
			slidesToShow: 3,
		  }
		}
	  ]
  });
 

  $('.counter').each(function () {
    $(this).prop('Counter',0).animate({
        Counter: $(this).text()
    }, {
        duration: 4000,
        easing: 'swing',
        step: function (now) {
            $(this).text(Math.ceil(now));
        }
    });
});





var grid = document.querySelector('.grid');
var iso = new Isotope( grid, {
	itemSelector: '.grid-item',
	layoutMode: 'masonry',
	masonry: {
		columnWidth: '.grid-sizer'
	}
});

// change is-checked class on buttons
var $buttonGroup = $('.filters');
$buttonGroup.on( 'click', 'li', function( event ) {
  $buttonGroup.find('.is-checked').removeClass('is-checked');
  var $button = $( event.currentTarget );
  $button.addClass('is-checked');
  var filterValue = $button.attr('data-filter');
  iso.arrange ({
	filter: filterValue
  });
});


if ($("body").hasClass("home")) {
	$(window).on('load', function () {
		$('video').trigger('play');
	  }) 
}

const players = Array.from(document.querySelectorAll('.player')).map((p) => new Plyr(p));
// const players = new Plyr('.player');

$('#heroVideo').on('shown.bs.modal', function (e) {
	players.forEach(function(player) {
		player.play();
  });});
$('#heroVideo').on('hidden.bs.modal', function (e) {
	players.forEach(function(player) {
		player.stop();
  });
});